/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteBankAccountApiResponse } from '../models/DeleteBankAccountApiResponse';
import type { GetBankAccountApiResponse } from '../models/GetBankAccountApiResponse';
import type { SaveBankAccountApiResponse } from '../models/SaveBankAccountApiResponse';
import type { SaveBankAccountDto } from '../models/SaveBankAccountDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppBankAccountService {
    /**
     * Get bank account details
     * Returns the authenticated expert's bank account with a masked account number (last 4 digits visible). Returns null data if no bank account is saved.
     * @returns GetBankAccountApiResponse Bank account fetched successfully
     * @throws ApiError
     */
    public static bankAccountControllerGetBankAccountV1(): CancelablePromise<GetBankAccountApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/bank-account',
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Create or update bank account
     * Saves the expert's bank account details. If an account already exists it is updated (upsert). The account number is encrypted with AES-256-GCM before storage. confirmAccountNumber must match accountNumber.
     * @param requestBody
     * @returns SaveBankAccountApiResponse Bank account saved successfully
     * @throws ApiError
     */
    public static bankAccountControllerSaveBankAccountV1(
        requestBody: SaveBankAccountDto,
    ): CancelablePromise<SaveBankAccountApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/bank-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or account numbers do not match`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Delete bank account
     * Permanently removes the expert's saved bank account.
     * @returns DeleteBankAccountApiResponse Bank account deleted successfully
     * @throws ApiError
     */
    public static bankAccountControllerDeleteBankAccountV1(): CancelablePromise<DeleteBankAccountApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/expert-app/bank-account',
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                404: `No bank account found`,
            },
        });
    }
}
